module.exports = __webpack_public_path__ + "img/symbol_9.dd157912.png";